module.exports = __webpack_public_path__ + "0ecd01f218f4d01cc026d1c5ab51fd6a.ico";